module.exports = __webpack_public_path__ + "img/lluvia.96c6449c.svg";